<template>
<div @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
    <div v-if="!options" class="vap-cb">
        <div class="vap-cb-check" @click="handleClick">
            <div v-if="value" class="checkmark">
                <div class="checkmark_stem"></div>
                <div class="checkmark_kick"></div>
            </div>
        </div>
        <div class="vap-cb-text" @click="handleClick">
            <label>{{ text }}</label>
        </div>
    </div>
    <div v-for="(option, key) in options" :key="key" class="vap-cb" @mouseup="handleOptionMouseUp(key, $event)"
        :class="[{'vap-cb-inline' : inline}, {'vap-cb-radio' : radio}]">
        <div class="vap-cb-check" @click="handleClick(key)">
            <div v-if="value[key]" class="checkmark">
                <div class="checkmark_stem"></div>
                <div class="checkmark_kick"></div>
            </div>
        </div>
        <div class="vap-cb-text" @click="handleClick(key)">
            <label>{{ option.label }}</label>
        </div>
    </div>
</div>
</template>

<script>

export default {
    name: 'vm-checkbox',
    props: {
        value: {
			type: [Boolean, Object],
			default: false
		},
        text: {
            type: String,
            default: 'This is a checkbox'
        },
        id: {
			type: String,
			default: 'id'
        },
        activeLogic: {
			type: Boolean,
			default: false
        },
        options: {
            type: Object,
            default: null
        },
        inline: {
            type: Boolean,
            default: false
        },
        radio: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            objects: false
        }
    },
    methods: {
        handleClick(key) {
            if (this.objects) {
                let val = {};
                if (this.radio) {
                    for (let k in this.options) val[k] = false;
                    val[key] = true;
                }else {
                    for (let k in this.options) val[k] = this.value[k];
                    val[key] = !this.value[key];
                }
                console.log('sadsaf');
                this.$emit('input', val);
            }else {
                console.log('sadsaf');
                this.$emit('input', !this.value);
            }
        },
        handleMouseEnter(e) {
            this.$emit('connect-enter', this.id);
        },
        handleMouseLeave(e) {
            this.$emit('connect-leave', this.id);
        },
        handleOptionMouseUp(key, e) {
            if (this.activeLogic) {
                this.$emit('connect', key);
            }
        }
    },
    mounted() {
        if (this.options) {
            this.objects = true;
        }
    }
}
</script>
<style>

.vap-cb {
    float: left;
    width: 100%;
    display: flex;
    height: 25px;
    border-radius: 3px;
    /* border: solid 1px lightgray; */
}

.vap-cb-inline {
    width: auto;
}

.vap-cb-check {
    margin-top: 3px; margin-left: 3px;
    width: 16px; height: 16px;
    border: solid 1px #004976;
}
.vap-cb-radio .vap-cb-check {
    border-radius: 50%;
}

.vap-cb-text {
    margin-top: 3px;
    margin-left: 8px;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
}
.vap-cb-inline .vap-cb-text {
    margin-right: 15px;
}

.checkmark {
    display:inline-block;
    width: 22px;
    height:22px;
    -ms-transform: rotate(45deg); /* IE 9 */
    -webkit-transform: rotate(45deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
}

.checkmark_stem {
    position: absolute;
    width:4px;
    height:18px;
    background-color:#004976;
    left:8px;
    top:-3px;
}

.checkmark_kick {
    position: absolute;
    width:10px;
    height:4px;
    background-color:#004976;
    left:2px;
    top:12px;
}

</style>